<template>
  <!-- Figma S&R flow modal header (Scan / Leave / Add Service …): background-pattern band, 20px title, optional subtitle, red close -->
  <div
    class="fxModalHeader flex items-start justify-between gap-[10px] px-[15px] py-[14px] rounded-[10px] bg-cover bg-center font-roboto"
    :style="{ backgroundImage: `url(${bg})` }">
    <div class="min-w-0">
      <h5 class="m-0 text-[20px] font-semibold leading-[24px] text-[#333333]" :class="headerClass">{{ title }}
        <slot />
      </h5>
      <p v-if="subtitle" class="m-0 mt-[4px] text-[13px] leading-[16px] text-[#666666]">{{ subtitle }}</p>
    </div>
    <button type="button"
      class="w-[36px] h-[36px] flex-shrink-0 flex items-center justify-center border-0 bg-transparent p-0"
      :data-bs-dismiss="dismiss ? 'modal' : null" aria-label="Close" @click="$emit('close')">
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M6 6l12 12M18 6 6 18" stroke="#FF0004" stroke-width="2" stroke-linecap="round" />
      </svg>
    </button>
  </div>
</template>

<script>
import bg from "@/assets/images/body-Bg.png";

export default {
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: '' },
    // adds data-bs-dismiss="modal" to the close button (Bootstrap modals)
    dismiss: { type: Boolean, default: true },
    headerClass: { type: String, default: '' },
  },
  emits: ['close'],
  data() {
    return { bg };
  },
};
</script>
